export default "__VITE_ASSET__8502f4f9__"